import React, { Fragment } from "react";

import { Grid, makeStyles } from "@material-ui/core";
import { Save as SaveIcon } from "react-feather";
import clsx from "clsx";

import Button from "@ds-developer/button";

import { LearnerProgressProps } from "./types";
import { OverallProgress, SkillsAccordion } from "./components";

const useStyles = makeStyles(theme => ({
  grid: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  item: {
    marginBottom: theme.spacing(2),
    maxWidth: "600px",
  },
  buttonContainer: {
    justifyContent: "center",

    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-start",
    },
  },
}));

const LearnerProgress: React.FC<LearnerProgressProps> = ({
  loading = false,
  learnerProgress = undefined,
  onSaveClick = () => {},
}) => {
  const classes = useStyles();
  return (
    <Fragment>
      <Grid container className={classes.grid}>
        <Grid item container className={classes.item}>
          <OverallProgress loading={loading} />
        </Grid>
        <Grid item container className={classes.item} xs={12}>
          {(learnerProgress?.categories || []).map(category => (
            <SkillsAccordion
              key={category.id}
              skillCategoryId={category.id}
              loading={loading}
            />
          ))}
        </Grid>
        <Grid
          item
          container
          className={clsx(classes.item, classes.buttonContainer)}
          xs={12}
        >
          <Button
            loading={loading}
            size="large"
            type="submit"
            variant="contained"
            color="primary"
            data-test="learner-progress-save-button"
            onClick={onSaveClick}
          >
            <SaveIcon size={14} /> Save progress report
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default LearnerProgress;
